import '../../src/javascripts/pc/application';
import '../../src/stylesheets/pc/application.scss';

require.context('images', true, /\.(png|jpg|jpeg|svg)$/);
